import { notifications } from "@mantine/notifications";
import {
  IconAlertTriangle,
  IconCheck,
  IconInfoCircle,
  IconX,
} from "@tabler/icons-react";

const ICON_SIZE = 18;

const base = {
  radius: "md",
  withBorder: true,
  autoClose: 3500,
  position: "top-right",
};

const variants = {
  success: { color: "teal", icon: <IconCheck size={ICON_SIZE} /> },
  error: { color: "red", icon: <IconX size={ICON_SIZE} />, autoClose: 5000 },
  info: { color: "blue", icon: <IconInfoCircle size={ICON_SIZE} /> },
  warning: { color: "yellow", icon: <IconAlertTriangle size={ICON_SIZE} /> },
};

const build = (variant, message, options = {}) => {
  const { title, ...rest } =
    typeof message === "object" ? message : { message };
  return { ...base, ...variants[variant], title, ...rest, ...options };
};

export const notify = {
  success: (message, options) =>
    notifications.show(build("success", message, options)),
  error: (message, options) =>
    notifications.show(build("error", message, options)),
  info: (message, options) =>
    notifications.show(build("info", message, options)),
  warning: (message, options) =>
    notifications.show(build("warning", message, options)),

  // Returns an id; resolve it with notify.done / notify.fail to swap the spinner for a result.
  loading: (message, options = {}) => {
    const id = options.id ?? `notify-${Date.now()}`;
    notifications.show({
      ...base,
      id,
      loading: true,
      autoClose: false,
      withCloseButton: false,
      message,
      ...options,
    });
    return id;
  },

  done: (id, message, options) =>
    notifications.update({
      id,
      loading: false,
      withCloseButton: true,
      ...build("success", message, options),
    }),

  fail: (id, message, options) =>
    notifications.update({
      id,
      loading: false,
      withCloseButton: true,
      ...build("error", message, options),
    }),
};
